import { useAuth0 } from '@auth0/auth0-react';

import { useToast } from 'src/shared/components/ui/use-toast';
import { Button } from 'src/shared/components/ui/buttons/button';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

interface MFAButtonProps {
  redirectUrl: string;
}

export function MFAButton({ redirectUrl }: MFAButtonProps) {
  const { toast } = useToast();
  const { user } = useAuth();
  const { loginWithRedirect } = useAuth0();

  async function requestMfa() {
    try {
      await loginWithRedirect({
        authorizationParams: {
          redirect_uri: redirectUrl,
          login_hint: JSON.stringify({ mfaEnrollment: true }),
        },
      });
    } catch {
      toast({
        title: 'Error',
        description: "Can't request MFA, try again or contact support.",
        variant: 'error',
      });
    }
  }

  return user ? (
    user.multifactor ? (
      <Button disabled>MFA already active</Button>
    ) : (
      <Button onClick={requestMfa}>Enroll MFA</Button>
    )
  ) : (
    <Button disabled>Unauthorized</Button>
  );
}
